import { Str } from './string'
import { Obj } from './object'

export const Util = {
  Str,
  Obj: Obj
}
